import * as React from "react";
import { Typography } from "@mui/material";
import WaveText from "./WaveText";
import { useLanguage } from "../../contexts/LanguageContext";

// How long each synonym stays on screen before cycling to the next one.
const CYCLE_INTERVAL_MS = 2200;

export default function ThinkingIndicator() {
  const { t, language } = useLanguage();

  const synonyms = React.useMemo(() => {
    const raw = t("chat.thinkingSynonyms", { returnObjects: true });
    return Array.isArray(raw) && raw.length > 0 ? (raw as string[]) : [t("chat.thinking")];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  // Random starting point so consecutive turns don't always open on the same word.
  const [index, setIndex] = React.useState(() => Math.floor(Math.random() * synonyms.length));

  React.useEffect(() => {
    setIndex(Math.floor(Math.random() * synonyms.length));
    const id = window.setInterval(() => {
      setIndex((i) => (i + 1) % synonyms.length);
    }, CYCLE_INTERVAL_MS);
    return () => window.clearInterval(id);
  }, [synonyms]);

  return (
    <WaveText>
      <Typography variant="body2" sx={{ color: "text.secondary", fontWeight: 500 }}>
        {synonyms[index % synonyms.length]}
      </Typography>
    </WaveText>
  );
}
